import {debounce} from '../../helpers'

export default () => {
  function breakEmail() {
    let emailWrappers = document.querySelectorAll('.wp-block-contact-people a.email');

    emailWrappers.forEach(wrapper => {
      let email = wrapper.querySelector('p');
      if (wrapper.offsetLeft + wrapper.offsetWidth <= email.offsetLeft + email.offsetWidth) {
        email.innerHTML = email.innerText.replace(/@/g, '<br>@');
      } else {
        if (email.innerHTML.includes('<br>')) {
          email.innerHTML = email.innerText.replace('<br>', '').replace(/\s/g, "");
        }
      }
    });
  }

  let dispatchCallback = debounce(function () {
    breakEmail();
  }, 200);

  window.onresize = function () {
    dispatchCallback();
  }

  breakEmail();
}
